import api from "../api";

export const sendMessage = async (payload) => {
  return api.post("/v0/partner/support", payload).then((res) => res.data);
};
